import { render, staticRenderFns } from "./PinnedActive3rdPartyVulns.vue?vue&type=template&id=5b8120a9&scoped=true"
import script from "./PinnedActive3rdPartyVulns.vue?vue&type=script&lang=ts"
export * from "./PinnedActive3rdPartyVulns.vue?vue&type=script&lang=ts"
import style0 from "./PinnedActive3rdPartyVulns.vue?vue&type=style&index=0&id=5b8120a9&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.28.5__cache-loader@4.1.0_web_440794991c458c99f4ea4042de23b4db/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8120a9",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ZIcon: require('/app/components/zeal/ZIcon/ZIcon.vue').default,ZButton: require('/app/components/zeal/ZButton/ZButton.vue').default,PinnableReportsList: require('/app/components/Reports/PinnableReportsList.vue').default,EmptyState: require('/app/components/Common/EmptyState.vue').default,UIDistributionBar: require('/app/components/Common/UI2/UIDistributionBar.vue').default,ChartContainer: require('/app/components/Reports/ChartContainer.vue').default})
